import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const PreviewContainer = styled.section`
  flex: 1 1 100%;
  align-items: flex-start;
  position: relative;

  @media (min-width: 768px) {
    flex: 1 1 48.5%;
    min-width: 48.5%;
    max-width: 670px;
    margin-right: 15px;
  }

  img {
    width: 100%;
    height: auto;
  }

  #lfc-door-pusher-image {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    pointer-events: none;

    @media (min-width: 768px) {
      min-width: 48.5%;
      max-width: 761px;  
    }
  }

`;
      
const languageSuffix = (language) => {
  switch (language) {
    case "sv": return "SE";
    case "no": return "NO";
    case "fi": return "FI";
    default: return "SE";
  }
};

const LfcPreview = (
  { updatingDimensions, imageId, imageBaseUrl, pusherImageUrl, assetBaseUrl, language, previewImageDefaultHanding }
) => (
  <PreviewContainer>
    {
      updatingDimensions ? <div className="lfc-loader" /> :
        <>
          <img
            src={
              imageId ? `${imageBaseUrl}${imageId}?d=1000x1000` : `${assetBaseUrl}/store/layout/imagemissing/imgmissing_SE_sq.png`
            }
            srcSet={
              imageId ?
                `
                ${imageBaseUrl}${imageId}?d=350x350 350w,
                ${imageBaseUrl}${imageId}?d=500x500 500w,
                ${imageBaseUrl}${imageId}?d=700x700 700w,
                ${imageBaseUrl}${imageId}?d=1000x1000 1000w 
              `
                : `${assetBaseUrl}/store/layout/imagemissing/imgmissing_${languageSuffix(language)}_sq.png`
            }
            alt="preview"
            width="1000"
            height="1000"
            sizes="
              (max-width: 375px) 414px,
              (max-width: 1024px) 414px,
              571px
            "
            id="lfc-door-preview-image"
            className={'img-responsive'}
            style={previewImageDefaultHanding || !imageId ? null : { transform: "scaleX(-1)" }}
          />

          {pusherImageUrl &&
            <img
              src={pusherImageUrl}
              srcSet={
                `
                ${pusherImageUrl}?d=350x350 350w,
                ${pusherImageUrl}?d=500x500 500w,
                ${pusherImageUrl}?d=700x700 700w,
                ${pusherImageUrl}?d=1000x1000 1000w 
              `
              }
              alt="preview"
              width="1000"
              height="1000"
              sizes="
              (max-width: 375px) 414px,
              (max-width: 1024px) 414px,
              571px
            "
              id="lfc-door-pusher-image"
              className={'img-responsive'}
            />}
        </>
    }
  </PreviewContainer>
);

LfcPreview.propTypes = {
  imageId: PropTypes.string,
  imageBaseUrl: PropTypes.string,
  pusherImageUrl: PropTypes.string,
}

export default LfcPreview;